module.exports = {
    regexp: /(ru|ua|by|kz|uz)$/,
    array: ['ru', 'ua', 'by', 'kz', 'uz'],
};
